import React from 'react';
import { styled } from '@linaria/react';
import { Icon } from '@vio/atlas/Icon';
type PriceWatchBellProps = {
  isToggleOn: boolean;
  handleClick: (event: React.SyntheticEvent<Element, Event>) => void;
  BottomSheet?: () => JSX.Element | null;
};
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wv3yqdl",
  propsAsIs: false
});
export const PriceWatchBell = ({
  isToggleOn,
  handleClick
}: PriceWatchBellProps) => {
  const onClick = (event: React.SyntheticEvent<Element, Event> | undefined) => {
    event?.preventDefault();
    event?.stopPropagation();
    event?.nativeEvent.stopImmediatePropagation();
  };
  return /* the onClick is to stop the event bubble and trigger the HotelCard Click */(
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
    <div onClick={onClick} aria-hidden="true">
      <Wrapper onClickCapture={handleClick}>
        <Icon name={isToggleOn ? 'BellCheck' : 'Bell'} size="md" />
      </Wrapper>
    </div>
  );
};

require("./PriceWatchBell.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceWatchBell.tsx");